import { Typography } from "@mui/material";
import { makeStyles } from "../../../providers/makeStyles";

const useStyles = makeStyles((theme, { disabled, marginLeft = 1 }) => ({
    label: {
        display: "flex",
        flexDirection: "column",
        opacity: disabled && .6,
        marginLeft: theme.spacing(marginLeft),
        marginTop: theme.spacing(.5)
    },
}));

export const OptionLabel = ({ label, subLabel, marginLeft }) => {
    const classes = useStyles({ marginLeft });

    return (
        <div className={classes.label}>
            <Typography>{label}</Typography>
            {subLabel && <Typography variant="caption">{subLabel}</Typography>}
        </div>
    );
};
